module.exports = __webpack_public_path__ + "img/dsci0025.e8bc6638.jpg";